import React from "react"
import { Switch, Route } from "react-router-dom"
import BaseLayout from "src/layouts/Base"
import ResourceType from "src/containers/ResourceType"
import withRouteValidation from "src/hocs/withRouteValidation"
import {
  RESOURCE_TYPES_URL,
  RESOURCE_TYPES_ID_URL,
  DEFAULT_ID_VALIDATION_CONFIG,
} from "src/constants/routeNames"

export default (
  <Route path={RESOURCE_TYPES_URL}>
    <BaseLayout title="Типы ресурсов">
      <Switch>
        <Route path={RESOURCE_TYPES_URL} exact component={ResourceType} />
        <Route
          path={RESOURCE_TYPES_ID_URL}
          exact
          component={withRouteValidation({
            routeValidationConfig: DEFAULT_ID_VALIDATION_CONFIG,
            isSideModal: true,
          })(ResourceType)}
        />
      </Switch>
    </BaseLayout>
  </Route>
)
